import { render, staticRenderFns } from "./BusinessContactDetails-Profile.vue?vue&type=template&id=1d10bd1c"
import script from "./BusinessContactDetails-Profile.vue?vue&type=script&lang=js"
export * from "./BusinessContactDetails-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports